import { gql, useQuery } from "@apollo/client";
import { SearchSelectInput } from "components/core";
import { FC } from "react";

interface MdaPickerProps {
  filter?: {
    ministry?: string;
    status?: string;
    type?: string;
  };
  id: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  setFieldTouched?: any;
  setFieldError?: any;
  rawId?: boolean;
  position?: "top" | "bottom";
}

const GET_MDAS = gql`
  query GetMdasSelect($ministry: ID, $status: MdaStatus, $type: MdaType) {
    mdas: getMdas(
      ministry: $ministry
      sort: "name"
      pageSize: 0
      status: $status
      type: $type
    ) {
      _id
      code
      name
    }
  }
`;

export const MdaPicker: FC<MdaPickerProps> = ({
  filter,
  id,
  label,
  rawId,
  placeholder,
  ...form
}) => {
  const { loading, data } = useQuery(GET_MDAS, {
    variables: {
      ...(filter ? filter : {}),
    },
    notifyOnNetworkStatusChange: false,
  });

  return (
    <SearchSelectInput
      {...form}
      id={id ?? "mda"}
      label={label ?? "MDA"}
      placeholder={placeholder ?? "Select MDA"}
      optionsLoading={loading}
      options={(data?.mdas ?? [])?.map((mda: any) => ({
        label: {
          title: mda.name as string,
        },
        value: rawId ? mda._id : mda,
      }))}
      disabled={form.disabled}
    />
  );
};

export default MdaPicker;
